import { render, staticRenderFns } from "./quattroValori.vue?vue&type=template&id=67df7a52"
import script from "./quattroValori.vue?vue&type=script&lang=js"
export * from "./quattroValori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports